// src/api/images.js
import axios from 'axios'
import AuthService from '@/service/authService'

export function sanitizeGroupName(n = '') {
  const s = String(n).trim().replace(/[\\/:*?"<>|]/g, '').replace(/\s+/g, ' ').slice(0, 180)
  return s
}

function headers() {
  const h = AuthService.authHeaders()
  if (!h?.Authorization) throw new Error('Not authenticated')
  return { headers: { ...h, 'Content-Type': 'application/json' } }
}

export async function listGroups() {
  const { data } = await axios.get('/images/groups', headers())
  return data.groups || []
}

export async function createGroup(name) {
  await axios.post('/images/groups', { name: sanitizeGroupName(name) }, headers())
}

export async function renameGroup(oldName, newName) {
  const oldSan = sanitizeGroupName(oldName)
  const newSan = sanitizeGroupName(newName)
  if (!oldSan || !newSan) throw new Error('Both oldName and newName are required')
  if (oldSan === newSan) return
  await axios.patch('/images/groups', { oldName: oldSan, newName: newSan }, headers())
}

export async function deleteGroup(name) {
  await axios.delete('/images/groups', { ...headers(), data: { name: sanitizeGroupName(name) } })
}

export async function listPreviews({ group = null, skip = 0, take = 60, q = '', sort = 'new' } = {}) {
  const { data } = await axios.get('/images/list', {
    ...headers(),
    params: { group, skip, take, q, sort }
  })
  return data
}

export async function moveImage({ filename, fromGroup = null, toGroup }) {
  await axios.post('/images/move', { filename, fromGroup, toGroup: sanitizeGroupName(toGroup) }, headers())
}

export async function uploadImages(files, { group = null } = {}) {
  const h = AuthService.authHeaders()
  if (!h?.Authorization) throw new Error('Not authenticated')
  const fd = new FormData()
  for (const f of files) fd.append('files', f)
  const { data } = await axios.post('/images/upload', fd, {
    headers: { ...h, 'Content-Type': 'multipart/form-data' },
    params: { group }
  })
  return data
}

export async function deleteImage(filename, group = null) {
  await axios.delete('/images/item', { ...headers(), data: { filename, group } })
}

export default {
  listGroups,
  createGroup,
  renameGroup,
  deleteGroup,
  listPreviews,
  moveImage,
  uploadImages,
  deleteImage,
  sanitizeGroupName
}
